<div class="demo-konva">
  <header class="demo-konva__header">
    <span class="demo-konva__title">upp-konva — laboratorio</span>
    <div class="demo-konva__toolbar">
      <button type="button" class="demo-konva__btn demo-konva__btn--ghost" (click)="exportJson()" data-id="konva-demo-export-json">
        Exportar JSON
      </button>
      <input
        #fileInput
        type="file"
        class="demo-konva__file-input"
        accept="application/json,.json"
        (change)="onImportFile($event)"
        data-id="konva-demo-import-json-input"
      />
      <button type="button" class="demo-konva__btn demo-konva__btn--ghost" (click)="fileInput.click()" data-id="konva-demo-import-json">
        Importar JSON
      </button>
      <button type="button" class="demo-konva__btn demo-konva__btn--ghost" (click)="toggleTheme()" data-id="konva-demo-theme-toggle">
        Tema: {{ useDarkTheme ? 'oscuro' : 'claro' }}
      </button>
    </div>
    @if (importError) {
      <p class="demo-konva__import-error" data-id="konva-demo-import-error" role="alert">{{ importError }}</p>
    }
  </header>

  <div class="demo-konva__main">
    <aside class="demo-konva__aside" data-id="konva-demo-panel">
      <section class="demo-konva__panel-section demo-konva__panel-section--palette">
        <h2 class="demo-konva__panel-heading">Añadir al plano</h2>
        <p class="demo-konva__panel-lead">
          Cada botón llama a <code>model.applyAreaFromSource</code> con un <code>UppKonvaShapeSource</code>; no se usa la API del stage.
        </p>
        <div class="demo-konva__palette" role="toolbar" aria-label="Añadir objetos al plano">
          @for (item of paletteEntries; track item.kind) {
            <button
              type="button"
              class="demo-konva__palette-btn"
              (click)="addShapeFromPalette(item.kind)"
              [attr.data-id]="item.dataId ?? null"
            >
              <span class="demo-konva__palette-sym" aria-hidden="true">{{ item.sym }}</span>
              <span class="demo-konva__palette-label">{{ item.label }}</span>
            </button>
          }
        </div>
        <button type="button" class="demo-konva__btn demo-konva__btn--danger-text" (click)="removeLastShape()" data-id="konva-demo-remove-last">
          Quitar última figura
        </button>
      </section>

      <section class="demo-konva__panel-section">
        <h3 class="demo-konva__panel-subheading">Modo del modelo</h3>
        <div class="demo-konva__btn-row" role="group" aria-label="Modo del modelo">
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="sceneMode === 'view'"
            (click)="setSceneMode('view')"
            data-id="konva-demo-mode-view"
          >
            VISTA
          </button>
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="sceneMode === 'edit'"
            (click)="setSceneMode('edit')"
            data-id="konva-demo-mode-edit"
          >
            EDICIÓN
          </button>
        </div>
      </section>

      <section class="demo-konva__panel-section">
        <h3 class="demo-konva__panel-subheading">Orientación del área</h3>
        <div class="demo-konva__btn-row" role="group" aria-label="Orientación del área">
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.orientation === 'PORTRAIT'"
            (click)="setOrientation('PORTRAIT')"
            data-id="konva-demo-orientation-portrait"
          >
            PORTRAIT
          </button>
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.orientation === 'LANDSCAPE'"
            (click)="setOrientation('LANDSCAPE')"
            data-id="konva-demo-orientation-landscape"
          >
            LANDSCAPE
          </button>
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.orientation === 'AUTO'"
            (click)="setOrientation('AUTO')"
            data-id="konva-demo-orientation-auto"
          >
            AUTO
          </button>
        </div>
      </section>

      <section class="demo-konva__panel-section">
        <h3 class="demo-konva__panel-subheading">Tamaño de etiqueta</h3>
        <div class="demo-konva__btn-row" role="group" aria-label="Tamaño de fuente del badge de etiquetas">
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.labelSize === 'SMALL'"
            (click)="setLabelFontSize('SMALL')"
            data-id="konva-demo-label-size-small"
          >
            SMALL
          </button>
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.labelSize === 'NORMAL'"
            (click)="setLabelFontSize('NORMAL')"
            data-id="konva-demo-label-size-normal"
          >
            NORMAL
          </button>
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.labelSize === 'LARGE'"
            (click)="setLabelFontSize('LARGE')"
            data-id="konva-demo-label-size-large"
          >
            LARGE
          </button>
        </div>
      </section>

      <section class="demo-konva__panel-section">
        <h3 class="demo-konva__panel-subheading">Modo dibujo del área</h3>
        <div class="demo-konva__btn-row" role="group" aria-label="Modo dibujo del área">
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.mode === 'SHAPES'"
            (click)="setAreaDrawMode('SHAPES')"
            data-id="konva-demo-area-mode-shapes"
          >
            SHAPES
          </button>
          <button
            type="button"
            class="demo-konva__btn"
            [class.demo-konva__btn--toggle-active]="model.area.mode === 'VERTEX'"
            (click)="setAreaDrawMode('VERTEX')"
            data-id="konva-demo-area-mode-vertex"
          >
            VERTEX
          </button>
        </div>
      </section>

      <section class="demo-konva__panel-section">
        <h3 class="demo-konva__panel-subheading">Estado</h3>
        <div class="demo-konva__room-size" data-id="konva-demo-room-size">
          <label class="demo-konva__field">
            <span class="demo-konva__field-label">Ancho sala (cm)</span>
            <input
              class="demo-konva__field-input"
              type="number"
              name="roomW"
              min="1"
              step="1"
              [(ngModel)]="roomWidthCm"
              data-id="konva-demo-room-width"
            />
          </label>
          <label class="demo-konva__field">
            <span class="demo-konva__field-label">Alto sala (cm)</span>
            <input
              class="demo-konva__field-input"
              type="number"
              name="roomH"
              min="1"
              step="1"
              [(ngModel)]="roomHeightCm"
              data-id="konva-demo-room-height"
            />
          </label>
          <button
            type="button"
            class="demo-konva__btn"
            (click)="applyRoomDimensions()"
            data-id="konva-demo-room-apply"
          >
            Aplicar
          </button>
        </div>
        <ul class="demo-konva__list">
          <li>
            Orientación: {{ model.area.orientation }} · Dibujo: {{ model.area.mode }} · Etiquetas:
            {{ model.area.labelSize }}
          </li>
          <li>Figuras: {{ model.area.shapes.length }}</li>
        </ul>
      </section>

      <section class="demo-konva__panel-section">
        <h3 class="demo-konva__panel-subheading">Figuras en el modelo</h3>
        <ul class="demo-konva__list demo-konva__list--mono">
          @for (s of model.area.shapes; track s.id) {
            <li>{{ s.kind }} · {{ s.id.slice(0, 8) }}… · {{ s.x }},{{ s.y }} {{ s.width }}×{{ s.height }}</li>
          } @empty {
            <li class="demo-konva__list-empty">Ninguna — usa la paleta</li>
          }
        </ul>
      </section>

      <section class="demo-konva__panel-section demo-konva__panel-section--muted">
        <h3 class="demo-konva__panel-subheading">exportModel() (stub)</h3>
        <pre class="demo-konva__pre">{{ stubExportModel() || '(vacío)' }}</pre>
      </section>
    </aside>

    <div class="demo-konva__canvas-wrap" data-id="konva-demo-host">
      @if (model) {
        <upp-konva
          [model]="model"
          [active]="true"
          [theme]="themePreset"
          (onChange)="onModelStructuralChange()"
          (onSelect)="onCanvasSelectionChange($event)"
        ></upp-konva>
      }
    </div>

    <aside class="demo-konva__inspector" data-id="konva-demo-inspector" aria-label="Propiedades de la figura seleccionada">
      <h2 class="demo-konva__panel-heading">
        @if (canvasSelection.length > 1) {
          Figuras seleccionadas
        } @else {
          Figura seleccionada
        }
      </h2>
      <p class="demo-konva__panel-lead">
        Evento <code>(onSelect)</code> de <code>upp-konva</code> (instancias <code>UppKonvaShape</code>). Geometría en común →
        <code>notifyPresentationDirty</code> + repintado; forma / <code>data</code> →
        <code>shape.syncPresentationToStage()</code> (sin mover la caja del lienzo).
      </p>

      @if (canvasSelection.length === 0) {
        <p class="demo-konva__inspector-hint" data-id="konva-demo-inspector-empty">Selecciona una figura en el lienzo.</p>
      } @else if (canvasSelection.length > 1 && sceneMode === 'view') {
        <div class="demo-konva__inspector-readonly-block" data-id="konva-demo-inspector-multi-view">
          <p class="demo-konva__inspector-hint">{{ canvasSelection.length }} elementos (solo lectura).</p>
          <ul class="demo-konva__inspector-multi-list">
            @for (sh of canvasSelection; track sh.id) {
              <li>
                <span class="demo-konva__inspector-mono">{{ sh.id }}</span>
                — {{ sh.kind }}
              </li>
            }
          </ul>
        </div>
      } @else if (canvasSelection.length > 1 && sceneMode === 'edit' && inspectorMultiUniformReady()) {
        <form
          class="demo-konva__inspector-form"
          data-id="konva-demo-inspector-multi-form"
          (ngSubmit)="$event.preventDefault()"
        >
          <p class="demo-konva__inspector-hint">
            {{ inspectorMultiShapes.length }} figuras · kind <strong>{{ inspectorMultiUniformKind }}</strong>
            @if (inspectorMultiUniformKind !== 'VERTEX') {
              — los valores de geometría se aplican a todas.
            } @else {
              — alinear/repartir según la vista; la geometría uniforme no aplica a vértices de perímetro.
            }
          </p>
          @if (inspectorMultiUniformKind !== 'VERTEX') {
            <fieldset class="demo-konva__inspector-fieldset">
              <legend class="demo-konva__inspector-legend">Geometría común (cm / °)</legend>
              <label class="demo-konva__field">
                <span class="demo-konva__field-label">Ancho (cm)</span>
                <input
                  class="demo-konva__field-input"
                  type="number"
                  name="mw"
                  min="1"
                  step="1"
                  [(ngModel)]="multiGeomWidthCm"
                  (ngModelChange)="onMultiGeometryChange()"
                />
              </label>
              <label class="demo-konva__field">
                <span class="demo-konva__field-label">Alto (cm)</span>
                <input
                  class="demo-konva__field-input"
                  type="number"
                  name="mh"
                  min="1"
                  step="1"
                  [(ngModel)]="multiGeomHeightCm"
                  (ngModelChange)="onMultiGeometryChange()"
                />
              </label>
              <label class="demo-konva__field">
                <span class="demo-konva__field-label">Rotación (°)</span>
                <input
                  class="demo-konva__field-input"
                  type="number"
                  name="mr"
                  step="1"
                  [(ngModel)]="multiGeomRotationDeg"
                  (ngModelChange)="onMultiGeometryChange()"
                />
              </label>
            </fieldset>
          }

          @if (inspectorMultiUniformKind === 'TABLE') {
            <fieldset class="demo-konva__inspector-fieldset">
              <legend class="demo-konva__inspector-legend">Mesa (todas)</legend>
              <label class="demo-konva__field">
                <span class="demo-konva__field-label">Forma mesa</span>
                <select
                  class="demo-konva__field-input"
                  data-id="konva-demo-inspector-multi-table-shape"
                  name="mtshape"
                  [ngModel]="inspectorTableShapeControl"
                  (ngModelChange)="onMultiInspectorTableShapeControlChange($event)"
                >
                  @for (opt of inspectorTableShapes; track opt) {
                    <option [ngValue]="opt">{{ opt === 'CIRCLE' ? 'Redonda' : 'Cuadrada' }}</option>
                  }
                </select>
              </label>
              <label class="demo-konva__field">
                <span class="demo-konva__field-label">Sillas</span>
                <input
                  class="demo-konva__field-input"
                  type="number"
                  name="mtchairs"
                  min="0"
                  step="1"
                  [(ngModel)]="multiInspectorChairs"
                  (ngModelChange)="onMultiChairsChange($event)"
                />
              </label>
            </fieldset>
          }

          <div class="demo-konva__inspector-align-dist">
            <p class="demo-konva__inspector-hint">
              Respecto a la vista: <strong>vertical</strong> = misma columna; <strong>horizontal</strong> = misma fila.
              Reparto = huecos iguales entre bordes proyectados.
            </p>
            <fieldset class="demo-konva__inspector-fieldset">
              <legend class="demo-konva__inspector-legend">Alinear</legend>
              <div class="demo-konva__inspector-btn-row">
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--inspector-pair"
                  (click)="onMultiAlign('vertical')"
                  data-id="konva-demo-inspector-align-vertical"
                >
                  Alinear vertical
                </button>
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--inspector-pair"
                  (click)="onMultiAlign('horizontal')"
                  data-id="konva-demo-inspector-align-horizontal"
                >
                  Alinear horizontal
                </button>
              </div>
            </fieldset>
            <fieldset class="demo-konva__inspector-fieldset">
              <legend class="demo-konva__inspector-legend">Repartir</legend>
              <div class="demo-konva__inspector-btn-row">
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--inspector-pair"
                  (click)="onMultiDistribute('vertical')"
                  data-id="konva-demo-inspector-distribute-vertical"
                >
                  Repartir vertical
                </button>
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--inspector-pair"
                  (click)="onMultiDistribute('horizontal')"
                  data-id="konva-demo-inspector-distribute-horizontal"
                >
                  Repartir horizontal
                </button>
              </div>
            </fieldset>
          </div>
          <div class="demo-konva__inspector-actions">
            <button
              type="button"
              class="demo-konva__btn demo-konva__btn--danger-text"
              (click)="deleteInspectorMultiShapes()"
              data-id="konva-demo-inspector-delete-multi"
            >
              Eliminar {{ inspectorMultiShapes.length }} figuras
            </button>
          </div>
        </form>
      } @else if (canvasSelection.length > 1 && sceneMode === 'edit') {
        <p class="demo-konva__inspector-hint" data-id="konva-demo-inspector-multi">
          Hay {{ canvasSelection.length }} elementos seleccionados. El panel común aparece si todos son del mismo tipo
          y cada uno tiene fila en el modelo.
        </p>
        <div class="demo-konva__inspector-actions">
          <button
            type="button"
            class="demo-konva__btn demo-konva__btn--danger-text"
            (click)="deleteHeterogeneousCanvasSelection()"
            data-id="konva-demo-inspector-delete-heterogeneous"
          >
            Eliminar selección ({{ canvasSelection.length }})
          </button>
        </div>
      } @else if (sceneMode === 'view') {
        <div class="demo-konva__inspector-readonly-block" data-id="konva-demo-inspector-view">
          <dl class="demo-konva__inspector-dl">
            <dt>Id fila / lienzo</dt>
            <dd class="demo-konva__inspector-mono">{{ canvasSelection[0].id }}</dd>
            <dt>Etiqueta</dt>
            <dd>{{ canvasSelection[0].label || '—' }}</dd>
            <dt>Subetiqueta</dt>
            <dd>{{ canvasSelection[0].sublabel || '—' }}</dd>
            <dt>Resaltado atención</dt>
            <dd>{{ model.area.findShapeById(canvasSelection[0].id)?.attention ? 'Sí' : 'No' }}</dd>
            @if (inspectorViewHighlightEnabled()) {
              <dt>Tono / animación</dt>
              <dd>{{ inspectorHighlightSummaryText() }}</dd>
            }
            @if (inspectorShape) {
              <dt>Kind</dt>
              <dd>{{ inspectorShape.kind }}</dd>
              <dt>x (cm)</dt>
              <dd>{{ inspectorShape.x }}</dd>
              <dt>y (cm)</dt>
              <dd>{{ inspectorShape.y }}</dd>
              <dt>Ancho (cm)</dt>
              <dd>{{ inspectorShape.width }}</dd>
              <dt>Alto (cm)</dt>
              <dd>{{ inspectorShape.height }}</dd>
              <dt>Rotación (°)</dt>
              <dd>{{ inspectorShape.rotation }}</dd>
              <dt>data (JSON)</dt>
              <dd class="demo-konva__inspector-data-preview">{{ inspectorShapeDataPreview() }}</dd>
            } @else {
              <dt>Área pública</dt>
              <dd>Sin fila enlazada en <code>area.shapes</code> para este id.</dd>
            }
          </dl>
          <div class="demo-konva__inspector-actions">
            <button
              type="button"
              class="demo-konva__btn"
              [disabled]="inspectorAttentionToggleDisabled()"
              (click)="toggleInspectorAttention()"
              data-id="konva-demo-inspector-attention"
            >
              {{ inspectorAttentionButtonLabel() }}
            </button>
          </div>
          @if (inspectorViewHighlightEnabled()) {
            <p class="demo-konva__inspector-hint demo-konva__inspector-hint--tight">Probar API <code>setHighlight</code>:</p>
            <div class="demo-konva__inspector-highlight-grid" data-id="konva-demo-inspector-highlight-grid">
              <span class="demo-konva__inspector-highlight-label">Con pulso</span>
              <div class="demo-konva__inspector-highlight-btns">
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--compact"
                  (click)="setInspectorViewHighlight('SUCCESS', true)"
                  data-id="konva-demo-highlight-success-pulse"
                >
                  SUCCESS
                </button>
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--compact"
                  (click)="setInspectorViewHighlight('WARNING', true)"
                  data-id="konva-demo-highlight-warning-pulse"
                >
                  WARNING
                </button>
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--compact"
                  (click)="setInspectorViewHighlight('DANGER', true)"
                  data-id="konva-demo-highlight-danger-pulse"
                >
                  DANGER
                </button>
              </div>
              <span class="demo-konva__inspector-highlight-label">Solo color</span>
              <div class="demo-konva__inspector-highlight-btns">
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--compact"
                  (click)="setInspectorViewHighlight('SUCCESS', false)"
                  data-id="konva-demo-highlight-success-static"
                >
                  SUCCESS
                </button>
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--compact"
                  (click)="setInspectorViewHighlight('WARNING', false)"
                  data-id="konva-demo-highlight-warning-static"
                >
                  WARNING
                </button>
                <button
                  type="button"
                  class="demo-konva__btn demo-konva__btn--compact"
                  (click)="setInspectorViewHighlight('DANGER', false)"
                  data-id="konva-demo-highlight-danger-static"
                >
                  DANGER
                </button>
              </div>
            </div>
            <div class="demo-konva__inspector-actions">
              <button
                type="button"
                class="demo-konva__btn demo-konva__btn--ghost"
                (click)="clearInspectorViewHighlight()"
                data-id="konva-demo-inspector-highlight-clear"
              >
                Quitar resaltado
              </button>
            </div>
          } @else {
            <p class="demo-konva__inspector-hint demo-konva__inspector-hint--tight">
              El resaltado con tono y pulso solo aplica a <strong>mesas</strong> (kind TABLE).
            </p>
          }
          <p class="demo-konva__inspector-hint">
            Modo vista: solo lectura. En mesas, «Resaltar» usa <code>WARNING</code> con pulso; los botones llaman a
            <code>setHighlight(tone, animated)</code>.
          </p>
        </div>
      } @else if (!inspectorShape) {
        <p class="demo-konva__inspector-hint" data-id="konva-demo-inspector-miss">
          No hay figura en el modelo enlazada al id <code>{{ canvasSelection[0].id.slice(0, 12) }}…</code> — no se puede
          editar campos del DTO.
        </p>
      } @else {
        <form class="demo-konva__inspector-form" data-id="konva-demo-inspector-form" (ngSubmit)="$event.preventDefault()">
          <fieldset class="demo-konva__inspector-fieldset">
            <legend class="demo-konva__inspector-legend">Común</legend>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">Kind</span>
              <input class="demo-konva__field-input" type="text" [value]="inspectorShape.kind" readonly />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">Etiqueta</span>
              <input
                class="demo-konva__field-input"
                type="text"
                name="ilabel"
                autocomplete="off"
                data-id="konva-demo-inspector-label"
                [(ngModel)]="inspectorShape.label"
                (ngModelChange)="onInspectorLabelPresentationChange()"
              />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">Subetiqueta</span>
              <input
                class="demo-konva__field-input"
                type="text"
                name="isublabel"
                autocomplete="off"
                data-id="konva-demo-inspector-sublabel"
                [(ngModel)]="inspectorShape.sublabel"
                (ngModelChange)="onInspectorLabelPresentationChange()"
              />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">x (cm)</span>
              <input
                class="demo-konva__field-input"
                type="number"
                name="ix"
                [(ngModel)]="inspectorShape.x"
                (ngModelChange)="onInspectorGeometryChange()"
              />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">y (cm)</span>
              <input
                class="demo-konva__field-input"
                type="number"
                name="iy"
                [(ngModel)]="inspectorShape.y"
                (ngModelChange)="onInspectorGeometryChange()"
              />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">Ancho (cm)</span>
              <input
                class="demo-konva__field-input"
                type="number"
                name="iw"
                [(ngModel)]="inspectorShape.width"
                (ngModelChange)="onInspectorGeometryChange()"
              />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">Alto (cm)</span>
              <input
                class="demo-konva__field-input"
                type="number"
                name="ih"
                [(ngModel)]="inspectorShape.height"
                (ngModelChange)="onInspectorGeometryChange()"
              />
            </label>
            <label class="demo-konva__field">
              <span class="demo-konva__field-label">Rotación (°)</span>
              <input
                class="demo-konva__field-input"
                type="number"
                name="ir"
                [(ngModel)]="inspectorShape.rotation"
                (ngModelChange)="onInspectorGeometryChange()"
              />
            </label>
          </fieldset>

          <div class="demo-konva__inspector-actions">
            <button
              type="button"
              class="demo-konva__btn"
              (click)="toggleInspectorAttention()"
              data-id="konva-demo-inspector-attention-edit"
            >
              {{ inspectorAttentionButtonLabel() }}
            </button>
            <button
              type="button"
              class="demo-konva__btn demo-konva__btn--danger-text"
              (click)="deleteInspectorSingleShape()"
              data-id="konva-demo-inspector-delete-single"
            >
              Eliminar figura
            </button>
          </div>

          <fieldset class="demo-konva__inspector-fieldset">
            <legend class="demo-konva__inspector-legend">Según tipo</legend>
            @switch (inspectorShape.kind) {
              @case ('TABLE') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Forma mesa</span>
                  <select
                    class="demo-konva__field-input"
                    data-id="konva-demo-inspector-table-shape"
                    name="itableshape"
                    [ngModel]="inspectorTableShapeControl"
                    (ngModelChange)="onInspectorTableShapeControlChange($event)"
                  >
                    @for (opt of inspectorTableShapes; track opt) {
                      <option [ngValue]="opt">{{ opt === 'CIRCLE' ? 'Redonda' : 'Cuadrada' }}</option>
                    }
                  </select>
                </label>
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Sillas</span>
                  <input
                    class="demo-konva__field-input"
                    type="number"
                    name="itchairs"
                    min="0"
                    step="1"
                    [ngModel]="inspectorDataNumber('chairs', 4)"
                    (ngModelChange)="setInspectorDataNumber('chairs', $event)"
                  />
                </label>
              }
              @case ('BAR') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Forma barra</span>
                  <select
                    class="demo-konva__field-input"
                    name="ibarshape"
                    [ngModel]="inspectorBarShapeControl"
                    (ngModelChange)="onInspectorBarShapeControlChange($event)"
                  >
                    @for (opt of inspectorBarShapes; track opt) {
                      <option [ngValue]="opt">{{ opt }}</option>
                    }
                  </select>
                </label>
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Taburetes izq.</span>
                  <input
                    class="demo-konva__field-input"
                    type="number"
                    name="istl"
                    min="0"
                    step="1"
                    [ngModel]="inspectorDataNumber('stoolLeft', 0)"
                    (ngModelChange)="setInspectorDataNumber('stoolLeft', $event)"
                  />
                </label>
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Taburetes frente</span>
                  <input
                    class="demo-konva__field-input"
                    type="number"
                    name="istf"
                    min="0"
                    step="1"
                    [ngModel]="inspectorDataNumber('stoolFront', 0)"
                    (ngModelChange)="setInspectorDataNumber('stoolFront', $event)"
                  />
                </label>
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Taburetes dcha.</span>
                  <input
                    class="demo-konva__field-input"
                    type="number"
                    name="istr"
                    min="0"
                    step="1"
                    [ngModel]="inspectorDataNumber('stoolRight', 0)"
                    (ngModelChange)="setInspectorDataNumber('stoolRight', $event)"
                  />
                </label>
              }
              @case ('DOOR') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Variante puerta</span>
                  <select
                    class="demo-konva__field-input"
                    name="idoorshape"
                    [ngModel]="inspectorDoorShapeControl"
                    (ngModelChange)="onInspectorDoorShapeControlChange($event)"
                  >
                    @for (opt of inspectorDoorShapes; track opt) {
                      <option [ngValue]="opt">{{ opt }}</option>
                    }
                  </select>
                </label>
              }
              @case ('WINDOW') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Variante ventana</span>
                  <select
                    class="demo-konva__field-input"
                    name="iwinshape"
                    [ngModel]="inspectorWindowShapeControl"
                    (ngModelChange)="onInspectorWindowShapeControlChange($event)"
                  >
                    @for (opt of inspectorWindowShapes; track opt) {
                      <option [ngValue]="opt">{{ opt }}</option>
                    }
                  </select>
                </label>
              }
              @case ('STAIRS') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Variante escaleras</span>
                  <select
                    class="demo-konva__field-input"
                    name="istairshape"
                    [ngModel]="inspectorStairsShapeControl"
                    (ngModelChange)="onInspectorStairsShapeControlChange($event)"
                  >
                    @for (opt of inspectorStairsShapes; track opt) {
                      <option [ngValue]="opt">{{ opt }}</option>
                    }
                  </select>
                </label>
              }
              @case ('SOFA') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Forma sofá</span>
                  <select
                    class="demo-konva__field-input"
                    name="isofashape"
                    [ngModel]="inspectorSofaShapeControl"
                    (ngModelChange)="onInspectorSofaShapeControlChange($event)"
                  >
                    @for (opt of inspectorSofaShapes; track opt) {
                      <option [ngValue]="opt">{{ opt }}</option>
                    }
                  </select>
                </label>
              }
              @case ('GENERIC') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Forma genérica</span>
                  <select
                    class="demo-konva__field-input"
                    name="igenshape"
                    [ngModel]="inspectorGenericShapeControl"
                    (ngModelChange)="onInspectorGenericShapeControlChange($event)"
                  >
                    @for (opt of inspectorGenericShapes; track opt) {
                      <option [ngValue]="opt">{{ opt }}</option>
                    }
                  </select>
                </label>
              }
              @case ('VERTEX') {
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Orden (sort)</span>
                  <input
                    class="demo-konva__field-input"
                    type="number"
                    name="ivsort"
                    step="1"
                    [ngModel]="inspectorDataNumber('sort', 0)"
                    (ngModelChange)="setInspectorDataNumber('sort', $event)"
                  />
                </label>
                <label class="demo-konva__field demo-konva__field--checkbox">
                  <input
                    type="checkbox"
                    name="ivclosed"
                    [ngModel]="inspectorDataBool('closed')"
                    (ngModelChange)="setInspectorDataBool('closed', $event)"
                  />
                  <span class="demo-konva__field-label demo-konva__field-label--inline">Polígono cerrado</span>
                </label>
                <label class="demo-konva__field">
                  <span class="demo-konva__field-label">Id. polígono</span>
                  <input
                    class="demo-konva__field-input"
                    type="text"
                    name="ivpoly"
                    [ngModel]="inspectorDataString('poligon', '')"
                    (ngModelChange)="setInspectorDataString('poligon', $event)"
                  />
                </label>
              }
              @case ('BILLIARD') {
                <p class="demo-konva__inspector-hint">Sin campos <code>data</code> en el contrato actual.</p>
              }
              @case ('FOOTBALL') {
                <p class="demo-konva__inspector-hint">Sin campos <code>data</code> en el contrato actual.</p>
              }
            }
          </fieldset>
        </form>
      }
    </aside>
  </div>
</div>
